import { z } from 'zod';
import { nameSchema } from './common.js';
export const MAX_ROOM_CAPACITY = 40;
export const roomCapacitySchema = z
    .number()
    .int('Capacity must be a whole number')
    .min(1, 'A room must hold at least one person')
    .max(MAX_ROOM_CAPACITY);
export const createRoomInputSchema = z.strictObject({
    name: nameSchema,
    maxCapacity: roomCapacitySchema,
});
export const updateRoomInputSchema = createRoomInputSchema
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
    error: 'Provide at least one field to update',
});
//# sourceMappingURL=rooms.js.map